import { CHAIN_ID } from "@mezo/sdk"
import {
  getOKXWallet,
  getUnisatWallet,
  getXverseWallet,
  mezoMatsnetTestnet,
} from "@mezo-org/passport"
import { Chain, getDefaultConfig, WalletList } from "@rainbow-me/rainbowkit"
import {
  metaMaskWallet,
  okxWallet,
  tahoWallet,
  zerionWallet,
} from "@rainbow-me/rainbowkit/wallets"
import { http } from "viem"
import { mainnet, sepolia } from "wagmi/chains"

import {
  GELATO_RELAY_API_KEY,
  MEZO_NETWORK,
  PROJECT_ID,
  RPC_URL_ETHEREUM,
  RPC_URL_MEZO,
  SDK_NETWORK,
} from "#/shared/constants"

type NetworkChain = [Chain, ...Chain[]]

type ChainsByNetwork = { [key in typeof SDK_NETWORK]: NetworkChain }

const appName = "Mezo Portal Dapp"

const localChain = {
  id: 31337,
  name: "Hardhat Local",
  nativeCurrency: {
    decimals: 18,
    name: "Ethereum",
    symbol: "ETH",
  },
  rpcUrls: {
    public: { http: ["http://localhost:8545"] },
    default: { http: ["http://localhost:8545"] },
  },
  testnet: true,
}

const sepoliaChain = {
  ...sepolia,
  rpcUrls: { default: { http: [RPC_URL_ETHEREUM ?? ""] } },
}

const mainnetChain = {
  ...mainnet,
  rpcUrls: { default: { http: [RPC_URL_ETHEREUM ?? ""] } },
}

export const chainsByNetwork: ChainsByNetwork = {
  local: [localChain, sepoliaChain, mainnetChain],
  sepolia: [sepoliaChain, mezoMatsnetTestnet],
  mainnet: [mainnetChain, mezoMatsnetTestnet], // TODO: Replace with mezo mainnet
}

const transports = {
  [SDK_NETWORK === "mainnet" ? mainnet.id : sepolia.id]: http(RPC_URL_ETHEREUM),
  // TODO: Value needs to be updated when we have chain available
  [MEZO_NETWORK === "mezo" ? mezoMatsnetTestnet.id : mezoMatsnetTestnet.id]:
    http(RPC_URL_MEZO),
}

export const rainbowKitConfig = {
  appName,
  transports,
  projectId: PROJECT_ID,
  chains: chainsByNetwork[SDK_NETWORK],
  multiInjectedProviderDiscovery: false,
}

export const ethereumWallets: WalletList = [
  {
    groupName: "Ethereum Wallets",
    wallets: [tahoWallet, metaMaskWallet, zerionWallet, okxWallet],
  },
]

const bitcoinWalletConfig = {
  rpcUrl: RPC_URL_ETHEREUM || "",
  chainId: CHAIN_ID[SDK_NETWORK],
  relayApiKey: GELATO_RELAY_API_KEY || "",
}

const unisatWallet = getUnisatWallet(bitcoinWalletConfig)
const okxBitcoinWallet = getOKXWallet(bitcoinWalletConfig)
const xverseWallet = getXverseWallet(bitcoinWalletConfig)

export const bitcoinWallets: WalletList = [
  {
    groupName: "Bitcoin Wallets",
    wallets: [unisatWallet, okxBitcoinWallet, xverseWallet],
  },
]

export const createWagmiConfig = (wallets: WalletList) =>
  getDefaultConfig({ ...rainbowKitConfig, wallets })
